import React from "react";
import { MessageCircle } from "lucide-react";
import { BUSINESS } from "@/constants/business";
import { trackContact } from "@/utils/analytics";

export default function WhatsAppFloat() {
  const link = `https://wa.me/${BUSINESS.whatsapp}?text=Hi%20Vila%20Elevators%2C%20I%27d%20like%20a%20quote`;
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      onClick={() => trackContact("whatsapp")}
      aria-label="Chat on WhatsApp"
      className="fixed bottom-24 right-6 z-40 w-14 h-14 rounded-full bg-green-600 hover:bg-green-500 flex items-center justify-center shadow-[0_0_25px_rgba(34,197,94,0.5)] transition-all hover:scale-110"
    >
      <MessageCircle className="w-6 h-6 text-[#1a1a1a]" fill="white" />
    </a>
  );
}
